import {
  isShadowValueScaled,
  TEXT_SHADOW_OFFSET_VALUE_TO_EM_COEF,
} from 'blocks/TextOverlayModal/v2/style-transform-utils';

export const getShadowValue = (value: number | undefined): number => {
  if (value === undefined) {
    return 0;
  }

  return isShadowValueScaled(value)
    ? value / TEXT_SHADOW_OFFSET_VALUE_TO_EM_COEF
    : value;
};
